import { Routes } from '@angular/router';
export const APPROUTES: Routes = [
    { path: 'login', loadChildren:'./login/login.module#LoginModule' },
    { path: 'forgotpassword', loadChildren:'./forgotpassword/forgotpassword.module#ForgotpasswordModule' },
    { path: 'resetpassword', loadChildren:'./resetpassword/resetpassword.module#ResetpasswordModule'},
    { path: 'unauthorized', loadChildren:'./unauthorized/unauthorized.module#UnauthorizedModule' },
    { path: 'setpassword', loadChildren:'./setpassword/setpassword.module#SetpasswordModule' },
    { path: '', redirectTo: '/login', pathMatch: 'full' }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts